import React, { useState, useEffect } from "react";
import styled from "styled-components";
import routes from "../../../../constants/RoutesData";
import Searchbox from "sushiweb/Searchbox";
import MenuItem from "sushiweb/MenuItem";
import { Accordion, Panel } from "sushiweb/Accordion";
import { useHistory } from "react-router-dom";
import { debounce, isMobile } from "../../../../utils";
import Button from "sushiweb/Button";
import { FlexContainer } from "../../../../constants/assets/containers";

const generateInputRegex = (value) => {
  const valueArr = value.split(" ");
  let regStr = "";
  for (let j = 0; j < valueArr.length; j++) {
    if (j !== 0) {
      regStr += " ";
    } else {
      regStr += "(^|.* )";
    }
    // the following if condition ensures "dr tr" doesnt match 'dr'iver cash 'tr'ansactions" but matches 'dr'iver 'tr'aining.
    // just using else part would enable this beahaviour
    // if (j !== valueArr.length) {
    //   regStr += valueArr[j] + "[^ ]*";
    // }
    // else {
    // regStr += valueArr[j] + ".*";
    // }
    regStr += valueArr[j] + ".*";
  }
  return new RegExp(regStr, "i");
};

const NavSidePanel = (props) => {
  const [searchInput, setSearchInput] = useState("");
  const [isPanelExpanded, setIsPanelExpanded] = useState("");
  const [titleList, setTitleList] = useState([]);
  const [titleListCopy, setTitleListCopy] = useState([]);
  const history = useHistory();
  const getPanelTitle = (navItem) => {
    return (
      <PanelContainer>
        <img src={routes.navItems[navItem].icon} alt="icon" />
        <span>{navItem}</span>
      </PanelContainer>
    );
  };

  const isActiveNavItem = (item) => {
    return (
      (searchInput && item && item.title === searchInput) ||
      history.location.pathname === item.path ||
      history.location.pathname.includes(item.path + "/")
    );
  };

  const getSubItem = (url) => {
    //get those routes for which we have permission and showInDashboard is true
    const routeItem = routes.routesData[url];
    return routeItem &&
      routeItem.showInDashboard &&
      props.menus.has(routeItem.menuName)
      ? routeItem
      : false;
  };

  const handleItemSelect = (path) => {
    isMobile() && props.closeSidePanel();
    history.push(path);
  };

  const getNavItems = (navItem) => {
    const routesArr = [];
    //iterate through all the urls in this heading
    routes.navItems[navItem].urls.map((item, idx) => {
      const subItem = getSubItem(item);
      const isActive = isActiveNavItem(subItem);
      if (subItem) {
        isActive
          ? routesArr.push(
              <div
                key={idx}
                color="inherit"
                onClick={() => handleItemSelect(subItem.path)}
                className="active cursor-pointer"
              >
                {subItem.title}
              </div>
            )
          : routesArr.push(
              <div
                key={idx}
                color="inherit"
                onClick={() => handleItemSelect(subItem.path)}
                className={"cursor-pointer"}
              >
                {subItem.title}
              </div>
            );
      }
    });
    return routesArr;
  };

  //   const checkPrefixInWord = (title,value) => {
  //     const arr = title.split(" ");
  //     let searchMatch = false;
  //     for(let i=0;i<arr.length; i++){
  //       if(arr[i].toLowerCase().indexOf(value.toLowerCase())===0){
  //         searchMatch = true;
  //         break;
  //       }
  //     }
  //     return searchMatch;
  //   };

  const checkIfPanelExpanded = (navItem, idx, val) => {
    let ifSearchMatches = false;
    for (let i = 0; i < routes.navItems[navItem].urls.length; i++) {
      let item = routes.navItems[navItem].urls[i];
      if (
        routes.routesData[item] &&
        routes.routesData[item].title
          .toLowerCase()
          .indexOf(val.toLowerCase()) === 0
      ) {
        ifSearchMatches = true;
        break;
      }
    }
    let returnValue = false;
    if (val) {
      returnValue = ifSearchMatches;
    } else {
      returnValue = routes.navItems[navItem].urls.includes(
        history.location.pathname
      );
    }
    for (let i = 0; i < routes.navItems[navItem].urls.length; i++) {
      if (
        history.location.pathname.includes(
          routes.navItems[navItem].urls[i] + "/"
        )
      ) {
        returnValue = true;
        break;
      }
    }
    if (returnValue) {
      setIsPanelExpanded(idx);
    }
    return returnValue;
  };

  const changePanelState = debounce((val) => {
    Object.keys(routes.navItems).map((subItem, index) => {
      checkIfPanelExpanded(subItem, index, val);
    });
  }, 500);

  const checkPrefixInString = (title, value) => {
    let ifMatches = false;
    const valueArr = value.split(" ");
    const titleArr = title.split(" ");
    for (let j = 0; j < valueArr.length; j++) {
      const val = valueArr[j];
      for (let i = 0; i < titleArr.length; i++) {
        if (val && titleArr[i].toLowerCase().indexOf(val.toLowerCase()) === 0) {
          ifMatches = true;
          break;
        }
      }
      if (ifMatches) {
        break;
      }
    }
    return ifMatches;
  };

  const getUpdatedTitleList = (val) => {
    const arr = [];
    var inputAsRegex = generateInputRegex(val);
    for (let i = 0; i < titleListCopy.length; i++) {
      const title = titleListCopy[i];
      if (!!title.match(inputAsRegex)) {
        arr.push(title);
      }
    }
    return arr;
  };

  const changePathBasedOnQuery = (query) => {
    let activeItem = null;
    for (const key in routes.routesData) {
      if (routes.routesData[key]["text"] === query) {
        activeItem = routes.routesData[key];
        break;
      }
    }
    if (activeItem) {
      history.push(activeItem.path);
    }
  };

  const handleChange = (e) => {
    setSearchInput(e);
    changePanelState(e);
    changePathBasedOnQuery(e);
  };

  const handleInputChange = (e) => {
    if (e) {
      const updatedTitleList = getUpdatedTitleList(e);
      setTitleList(updatedTitleList);
    } else {
      setTitleList(titleListCopy);
    }
  };

  useEffect(() => {
    if (history.location.pathname === "/") {
      setIsPanelExpanded("");
    } else {
      changePanelState("");
    }
  }, [history.location.pathname]);

  useEffect(() => {
    const arr = new Set();
    Object.keys(routes.routesData).map((key) => {
      if (
        key !== "/" &&
        routes.routesData[key].showInDashboard === true &&
        props.menus.has(routes.routesData[key].menuName)
      ) {
        arr.add(routes.routesData[key]["title"]);
      }
    });
    const tempArr = Array.from(arr);
    setTitleList(tempArr);
    setTitleListCopy(tempArr);
  }, []);

  return (
    <SidePanel className="sidePanel">
      <TopSection>
        {/* <Input value={searchInput} onChange={handleChange} className="mr-30 navInput" id="sushi-input" label="Search here" borderColor="#000" leftIcon={<SearchThick />} />  */}
        <SearchContainer>
          <Searchbox
            onCloseIconClick={() => handleInputChange("")}
            className="sushi-searchbox"
            placeholder="Search here"
            onChange={handleInputChange}
            onSelect={handleChange}
          >
            {titleList.map((title, index) => {
              return <MenuItem key={index} value={title} label={title} />;
            })}
          </Searchbox>
        </SearchContainer>
        <Accordion>
          {Object.keys(routes.navItems).map((val, idx) => {
            const items = getNavItems(val);
            if (items.length > 0) {
              return (
                <Panel
                  id="navPanel"
                  expanded={isPanelExpanded === idx}
                  key={idx}
                  title={getPanelTitle(val)}
                >
                  {items}
                </Panel>
              );
            } else {
              return <span key="" />;
            }
          })}
        </Accordion>
      </TopSection>
      <RiderAppContainer>
        <ButtonHolder>
          <Button id="sushi-button">Download rider app</Button>
        </ButtonHolder>
      </RiderAppContainer>
    </SidePanel>
  );
};

const SidePanel = styled.div`
  display: flex;
  flex-direction: column;
  height: ${isMobile() ? "calc(100vh - 100px)" : "100%"};
  overflow: scroll;
  justify-content: space-between;
  #sushi-input {
    margin: 10px 22px;
    border-radius: 6px;
  }
  & > div {
    height: ${isMobile() ? "unset" : "calc(100vh - 160px)"};
    overflow: ${isMobile() ? "unset" : "scroll"};
  }
`;

const TopSection = styled.div``;

const ButtonHolder = styled.div`
  margin: 20px 22px 0;
  button {
    width: ${isMobile() && "100%"};
  }
`;

const SearchContainer = styled.div`
  margin: 0 22px 20px;
  & > div {
    width: 100%;
  }
  .sushi-searchbox {
    height: 50px !important;
    min-height: unset;
    & > div > div > div > div {
      height: 50px !important;
    }
  }
`;

const RiderAppContainer = styled.div``;

const PanelContainer = styled(FlexContainer)`
  img {
    width: 16px;
    height: 16px;
    margin: 0 10px 0 22px;
  }
`;

export default NavSidePanel;
